export const FONT_SIZES = {
  TITLE: { xs: "4.85vw", sm: 20 },
  SUBTITLE: { xs: "3.88vw", sm: 16 },
  BODY: { xs: "3.88vw", sm: 14 },
  SECTIONHEADER: { xs: "3.4vw", sm: 14 },
  CAPTION: { xs: "2.91vw", sm: 12 },
  TINY: { xs: "2.91vw", sm: 11 },
};

export const BORDER_RADIUS = {
  CARD: "20px",
  IMAGE: "8px",
  CHIP: "6px",
};
